// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/common/time.proto
/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal.js";
// For Node.js to access named exports from CommonJS
const __m0 = 'default' in _m0 ? _m0.default : _m0;
export const protobufPackage = "squareup.common.time";
/**
 * An enum representation of the days of the week, consistent with the ISO 8601 standard and
 * {@link org.joda.time.DateTimeConstants}
 */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["UNKNOWN_DO_NOT_USE"] = 0] = "UNKNOWN_DO_NOT_USE";
    DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
    DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
    DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
    DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
    DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
    DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
    DayOfWeek[DayOfWeek["SUNDAY"] = 7] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
/** Represents a month in the Gregorian calendar. */
export var MonthOfYear;
(function (MonthOfYear) {
    MonthOfYear[MonthOfYear["MONTH_OF_YEAR_UNSPECIFIED"] = 0] = "MONTH_OF_YEAR_UNSPECIFIED";
    MonthOfYear[MonthOfYear["JANUARY"] = 1] = "JANUARY";
    MonthOfYear[MonthOfYear["FEBRUARY"] = 2] = "FEBRUARY";
    MonthOfYear[MonthOfYear["MARCH"] = 3] = "MARCH";
    MonthOfYear[MonthOfYear["APRIL"] = 4] = "APRIL";
    MonthOfYear[MonthOfYear["MAY"] = 5] = "MAY";
    MonthOfYear[MonthOfYear["JUNE"] = 6] = "JUNE";
    MonthOfYear[MonthOfYear["JULY"] = 7] = "JULY";
    MonthOfYear[MonthOfYear["AUGUST"] = 8] = "AUGUST";
    MonthOfYear[MonthOfYear["SEPTEMBER"] = 9] = "SEPTEMBER";
    MonthOfYear[MonthOfYear["OCTOBER"] = 10] = "OCTOBER";
    MonthOfYear[MonthOfYear["NOVEMBER"] = 11] = "NOVEMBER";
    MonthOfYear[MonthOfYear["DECEMBER"] = 12] = "DECEMBER";
})(MonthOfYear || (MonthOfYear = {}));
function createBaseDateTime() {
    return {
        $type: "squareup.common.time.DateTime",
        instantUsec: undefined,
        timezoneOffsetMin: undefined,
        posixTz: undefined,
        tzName: [],
        ordinal: undefined,
    };
}
export const DateTime = {
    $type: "squareup.common.time.DateTime",
    encode(message, writer = __m0.Writer.create()) {
        const unregisterLong = registerLong();
        try {
            if (message.instantUsec !== undefined) {
                writer.uint32(8).int64(message.instantUsec);
            }
            if (message.timezoneOffsetMin !== undefined) {
                writer.uint32(16).sint32(message.timezoneOffsetMin);
            }
            if (message.posixTz !== undefined) {
                writer.uint32(26).string(message.posixTz);
            }
            for (const v of message.tzName) {
                writer.uint32(34).string(v);
            }
            if (message.ordinal !== undefined) {
                writer.uint32(40).int64(message.ordinal);
            }
            return writer;
        }
        finally {
            unregisterLong();
        }
    },
    decode(input, length) {
        const unregisterLong = registerLong();
        try {
            const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
            let end = length === undefined ? reader.len : reader.pos + length;
            const message = createBaseDateTime();
            while (reader.pos < end) {
                const tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        if (tag !== 8) {
                            break;
                        }
                        message.instantUsec = longToNumber(reader.int64());
                        continue;
                    case 2:
                        if (tag !== 16) {
                            break;
                        }
                        message.timezoneOffsetMin = reader.sint32();
                        continue;
                    case 3:
                        if (tag !== 26) {
                            break;
                        }
                        message.posixTz = reader.string();
                        continue;
                    case 4:
                        if (tag !== 34) {
                            break;
                        }
                        message.tzName.push(reader.string());
                        continue;
                    case 5:
                        if (tag !== 40) {
                            break;
                        }
                        message.ordinal = longToNumber(reader.int64());
                        continue;
                }
                if ((tag & 7) === 4 || tag === 0) {
                    break;
                }
                reader.skipType(tag & 7);
            }
            return message;
        }
        finally {
            unregisterLong();
        }
    },
    create(base) {
        return DateTime.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDateTime();
        message.instantUsec = object.instantUsec ?? undefined;
        message.timezoneOffsetMin = object.timezoneOffsetMin ?? undefined;
        message.posixTz = object.posixTz ?? undefined;
        message.tzName = object.tzName?.map((e) => e) || [];
        message.ordinal = object.ordinal ?? undefined;
        return message;
    },
};
function createBaseDateTimeInterval() {
    return { $type: "squareup.common.time.DateTimeInterval", inclusiveStart: undefined, exclusiveEnd: undefined };
}
export const DateTimeInterval = {
    $type: "squareup.common.time.DateTimeInterval",
    encode(message, writer = __m0.Writer.create()) {
        if (message.inclusiveStart !== undefined) {
            DateTime.encode(message.inclusiveStart, writer.uint32(10).fork()).ldelim();
        }
        if (message.exclusiveEnd !== undefined) {
            DateTime.encode(message.exclusiveEnd, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDateTimeInterval();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.inclusiveStart = DateTime.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.exclusiveEnd = DateTime.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return DateTimeInterval.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDateTimeInterval();
        message.inclusiveStart = (object.inclusiveStart !== undefined && object.inclusiveStart !== null)
            ? DateTime.fromPartial(object.inclusiveStart)
            : undefined;
        message.exclusiveEnd = (object.exclusiveEnd !== undefined && object.exclusiveEnd !== null)
            ? DateTime.fromPartial(object.exclusiveEnd)
            : undefined;
        return message;
    },
};
function createBaseYearMonth() {
    return { $type: "squareup.common.time.YearMonth", year: undefined, monthOfYear: undefined };
}
export const YearMonth = {
    $type: "squareup.common.time.YearMonth",
    encode(message, writer = __m0.Writer.create()) {
        if (message.year !== undefined) {
            writer.uint32(8).int32(message.year);
        }
        if (message.monthOfYear !== undefined) {
            writer.uint32(16).int32(message.monthOfYear);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseYearMonth();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.year = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.monthOfYear = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return YearMonth.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseYearMonth();
        message.year = object.year ?? undefined;
        message.monthOfYear = object.monthOfYear ?? undefined;
        return message;
    },
};
function createBaseYearMonthDay() {
    return { $type: "squareup.common.time.YearMonthDay", year: undefined, monthOfYear: undefined, dayOfMonth: undefined };
}
export const YearMonthDay = {
    $type: "squareup.common.time.YearMonthDay",
    encode(message, writer = __m0.Writer.create()) {
        if (message.year !== undefined) {
            writer.uint32(8).int32(message.year);
        }
        if (message.monthOfYear !== undefined) {
            writer.uint32(16).int32(message.monthOfYear);
        }
        if (message.dayOfMonth !== undefined) {
            writer.uint32(24).int32(message.dayOfMonth);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseYearMonthDay();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.year = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.monthOfYear = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.dayOfMonth = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return YearMonthDay.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseYearMonthDay();
        message.year = object.year ?? undefined;
        message.monthOfYear = object.monthOfYear ?? undefined;
        message.dayOfMonth = object.dayOfMonth ?? undefined;
        return message;
    },
};
function createBaseLocalTime() {
    return {
        $type: "squareup.common.time.LocalTime",
        hourOfDay: undefined,
        minuteOfHour: undefined,
        secondOfMinute: undefined,
        millisOfSecond: undefined,
    };
}
export const LocalTime = {
    $type: "squareup.common.time.LocalTime",
    encode(message, writer = __m0.Writer.create()) {
        if (message.hourOfDay !== undefined) {
            writer.uint32(8).int32(message.hourOfDay);
        }
        if (message.minuteOfHour !== undefined) {
            writer.uint32(16).int32(message.minuteOfHour);
        }
        if (message.secondOfMinute !== undefined) {
            writer.uint32(24).int32(message.secondOfMinute);
        }
        if (message.millisOfSecond !== undefined) {
            writer.uint32(32).int32(message.millisOfSecond);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLocalTime();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.hourOfDay = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.minuteOfHour = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.secondOfMinute = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.millisOfSecond = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return LocalTime.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLocalTime();
        message.hourOfDay = object.hourOfDay ?? undefined;
        message.minuteOfHour = object.minuteOfHour ?? undefined;
        message.secondOfMinute = object.secondOfMinute ?? undefined;
        message.millisOfSecond = object.millisOfSecond ?? undefined;
        return message;
    },
};
function createBaseDayTime() {
    return { $type: "squareup.common.time.DayTime", dayOfWeek: undefined, timeAt: undefined };
}
export const DayTime = {
    $type: "squareup.common.time.DayTime",
    encode(message, writer = __m0.Writer.create()) {
        if (message.dayOfWeek !== undefined) {
            writer.uint32(8).int32(message.dayOfWeek);
        }
        if (message.timeAt !== undefined) {
            LocalTime.encode(message.timeAt, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDayTime();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.dayOfWeek = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.timeAt = LocalTime.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return DayTime.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDayTime();
        message.dayOfWeek = object.dayOfWeek ?? undefined;
        message.timeAt = (object.timeAt !== undefined && object.timeAt !== null)
            ? LocalTime.fromPartial(object.timeAt)
            : undefined;
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
const registerLong = () => {
    const backup = __m0.util.Long;
    __m0.util.Long = Long;
    __m0.configure();
    return () => {
        __m0.util.Long = backup;
        __m0.configure();
    };
};
